import {css, cva} from "@panda/css";

import {Text} from "@pg-design/text-module";

import {getRoomsFlatsLabelOf} from "../../constants/prices_address_rooms";
import {RoomsFilter} from "../../constants/rcn_rooms_filter";

interface Props {
    rooms: RoomsFilter;
}

export const PricesAddressTrendLegend = (props: Props) => {
    const {rooms} = props;

    return (
        <div className={legendStyle}>
            <div className={itemStyle}>
                <span className={dotStyle({tone: "above"})} />
                <Text variant="info_txt_1" as="span" color="var(--colors-gray-700)">
                    powyżej linii trendu
                </Text>
            </div>

            <div className={itemStyle}>
                <span className={dotStyle({tone: "below"})} />
                <Text variant="info_txt_1" as="span" color="var(--colors-gray-700)">
                    poniżej linii trendu
                </Text>
            </div>

            <div className={itemStyle}>
                <span className={trendLineStyle} />
                <Text variant="info_txt_1" as="span" color="var(--colors-gray-700)">
                    trend dla {getRoomsFlatsLabelOf(rooms)}
                </Text>
            </div>
        </div>
    );
};

const legendStyle = css({
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: 3
});

const itemStyle = css({
    display: "flex",
    alignItems: "center",
    gap: 1
});

const dotStyle = cva({
    base: {
        width: "10px",
        height: "10px",
        borderRadius: "50%",
        flexShrink: 0
    },
    variants: {
        tone: {
            above: {
                backgroundColor: "var(--colors-success)"
            },
            below: {
                backgroundColor: "var(--colors-warning)"
            }
        }
    }
});

const trendLineStyle = css({
    width: "24px",
    height: 0,
    borderTop: "2px dashed var(--colors-gray-700)",
    flexShrink: 0
});
import {css, cva} from "@panda/css";

import {Text} from "@pg-design/text-module";

import {getRoomsFlatsLabelOf} from "../../constants/prices_address_rooms";
import {RoomsFilter} from "../../constants/rcn_rooms_filter";

interface Props {
    rooms: RoomsFilter;
}

export const PricesAddressTrendLegend = (props: Props) => {
    const {rooms} = props;

    return (
        <div className={legendStyle}>
            <div className={itemStyle}>
                <span className={dotStyle({tone: "above"})} />
                <Text variant="info_txt_1" as="span" color="var(--colors-gray-700)">
                    powyżej linii trendu
                </Text>
            </div>

            <div className={itemStyle}>
                <span className={dotStyle({tone: "below"})} />
                <Text variant="info_txt_1" as="span" color="var(--colors-gray-700)">
                    poniżej linii trendu
                </Text>
            </div>

            <div className={itemStyle}>
                <span className={trendLineStyle} />
                <Text variant="info_txt_1" as="span" color="var(--colors-gray-700)">
                    trend dla {getRoomsFlatsLabelOf(rooms)}
                </Text>
            </div>
        </div>
    );
};

const legendStyle = css({
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: 3
});

const itemStyle = css({
    display: "flex",
    alignItems: "center",
    gap: 1
});

const dotStyle = cva({
    base: {
        width: "10px",
        height: "10px",
        borderRadius: "50%",
        flexShrink: 0
    },
    variants: {
        tone: {
            above: {
                backgroundColor: "var(--colors-success)"
            },
            below: {
                backgroundColor: "var(--colors-warning)"
            }
        }
    }
});

const trendLineStyle = css({
    width: "24px",
    height: 0,
    borderTop: "2px dashed var(--colors-gray-700)",
    flexShrink: 0
});
